module.exports = __webpack_public_path__ + "img/wxewm_03.020d381e.png";